import { Report } from "core/types/report.types";
import { actionCreatorFactory } from "typescript-fsa";

const actionCreator = actionCreatorFactory("report");

export const resetReport = actionCreator<void>("RESET");

export const isReportLoading = actionCreator<{
  isReportLoading: boolean;
}>("IS_REPORT_LOADING");

export const isDownloadReportLoading = actionCreator<{
  isDownloadReportLoading: boolean;
}>("IS_DOWNLOAD_REPORT_LOADING");

export const reportSuccess = actionCreator<{
  reportSuccess: string;
}>("REPORT_SUCCESS");

export const reportList = actionCreator<{
  reportList: Report[];
}>("REPORT_LIST");
